<template>
  <div v-if="item">
    <template v-for="(payment, index) in paymentTypes">
      <template v-if="hasPaymentTransactions">
        <template v-for="(transaction, idx) in paymentTransactions">
          <v-tooltip
            v-if="transaction.PaymentType === payment.code"
            :key="`payment-transaction-${index}-${idx}`"
            :color="payment.color2"
            right
          >
            <template #activator="{on}">
              <v-badge
                :color="badgeColor"
                :dot="badgeDot"
                :value="canShowBadge(transaction)"
                overlap
                right
              >
                <template #badge>
                  <v-icon
                    dark
                    small
                  >
                    {{ badgeIcon }}
                  </v-icon>
                </template>

                <img
                  v-if="!!payment.image"
                  :class="chip ? '' : 'mx-1'"
                  :height="dense ? 16 : 22"
                  :src="`${appConfig.LOCATION_DATA.CdnUrl}assets/payments/${payment.image}`"
                  style="margin-top: 2px; margin-bottom: 2px;"
                  width="auto"
                  v-on="on"
                >
                <v-icon
                  v-else
                  :class="chip ? '' : 'mx-1'"
                  :color="payment.color1"
                  :size="dense ? 20 : 26"
                  style="margin-top: 2px; margin-bottom: 2px;"
                  v-on="on"
                >
                  {{ payment.code === PaymentTypeEnum.CASH ? appCurrency.Icon : payment.icon }}
                </v-icon>
              </v-badge>
            </template>

            <span>
              {{ transaction.Amount | currency }} {{
                payment.code === PaymentTypeEnum.CASH ? $t('Order.PaymentMethod.Cash').Title.toLocaleUpperCase($i18n.locale) : payment.code === PaymentTypeEnum.CARD ? $t('Order.PaymentMethod.Card').Title.toLocaleUpperCase($i18n.locale) : payment.name.toLocaleUpperCase($i18n.locale)
              }}
            </span>
          </v-tooltip>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import AppData from '@/mixins/appdata'
import SourceTypeEnum from '@/api/Enums/SourceTypeEnum'
import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum'
import PaymentType from '@/mixins/orders/paymentType'
import FiscalDocsProviderTypeEnum from '@/api/Enums/FiscalDocsProviderTypeEnum.js'

export default {
  name      : 'OrderPaymentsIcon',
  components: {},
  directives: {},
  mixins    : [AppData, PaymentType],
  props     : {
    item: {
      type   : Object,
      default: undefined
    },
    paymentType: {
      type   : String,
      default: ''
    },
    dense: {
      type   : Boolean,
      default: false
    },
    chip: {
      type   : Boolean,
      default: false
    },
    badge: {
      type   : Boolean,
      default: false
    },
    badgeDot: {
      type   : Boolean,
      default: false
    },
    badgePaymentType: {
      type   : Array,
      default: () => PaymentTypeEnum.ALL_TYPES
    },
    badgeColor: {
      type   : String,
      default: 'red'
    },
    badgeIcon: {
      type   : String,
      default: 'priority_high'
    }
  },
  data() {
    return {}
  },
  computed: {
    PaymentTypeEnum() {
      return PaymentTypeEnum
    },
    SourceTypeEnum() {
      return SourceTypeEnum
    },

    hasPaymentTransactions() {
      const paymentTransactions = this.item?.PaymentTransactions || []

      return paymentTransactions.length > 0
    },
    paymentTransactions() {
      const transactions = []
      const paymentTransactions = this.item?.PaymentTransactions || []
      const transactionsGroupedByPaymentType = Object.groupBy(paymentTransactions, trx => trx.PaymentType)

      Object.keys(transactionsGroupedByPaymentType).forEach(key => {
        const transactionsTotal = transactionsGroupedByPaymentType[key]?.reduce((a, b) => a + parseFloat(b.Amount) || 0, 0) || 0

        transactions.push({
          Amount     : transactionsTotal.toFixed(2),
          PaymentType: key,
          HasPaidCard: PaymentTypeEnum.isEftPosPaymentType(key) && transactionsGroupedByPaymentType[key]?.some(t => t?.ResponseIntentResult === 'COMPLETED' && t?.ResponseIntentStatus === 'APPROVED')
        })
      })

      return transactions
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    canShowBadge(transaction) {
      return this.badge
          && this.appHasFiscalDocsProvider
          && this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD
          && this.badgePaymentType?.includes(transaction.PaymentType)
          && transaction.HasPaidCard
    }
  }
}
</script>

<style scoped>

</style>
